// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

.permission-group {
  margin-bottom: 0.5rem;
  padding: 0.5rem;
  padding-top: 0rem;
  border-bottom: 1px solid #D1D3D4;
}

.subject-label {
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.button-set {
  display: flex;
  gap: 0.5rem;
}

.perm-btn {
  padding: 0.5rem 1rem;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  font-size: 0.9rem;
  background-color: #eee;
  color: black;
  transition: all 0.2s ease-in-out;
}

.perm-btn.selected.view-only {
  background-color: #ADD8E6;
}

.perm-btn.selected.edit {
  background-color: #90EE90;
}

.perm-btn.selected.not-shared {
  background-color: #FFA07A;
}

.perm-btn:hover {
  opacity: 0.9;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/PermissionButtonGroup.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;AAFA;EACE,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,gCAAA;AAKF;;AAFA;EACE,iBAAA;EACA,qBAAA;AAKF;;AAFA;EACE,aAAA;EACA,WAAA;AAKF;;AAFA;EACE,oBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,YAAA;EACA,gCAAA;AAKF;;AAFA;EACE,yBDYgB;ACPlB;;AAFA;EACE,yBDSgB;ACJlB;;AAFA;EACE,yBDMkB;ACDpB;;AAFA;EACE,YAAA;AAKF","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"../styles/global/Colors\";\n\n.permission-group {\n  margin-bottom: 0.5rem;\n  padding: 0.5rem;\n  padding-top: 0rem;\n  border-bottom: 1px solid $grey1;\n}\n\n.subject-label {\n  font-weight: bold;\n  margin-bottom: 0.5rem;\n}\n\n.button-set {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.perm-btn {\n  padding: 0.5rem 1rem;\n  border: none;\n  cursor: pointer;\n  border-radius: 4px;\n  font-size: 0.9rem;\n  background-color: #eee;\n  color: black;\n  transition: all 0.2s ease-in-out;\n}\n\n.perm-btn.selected.view-only {\n  background-color: $permission-blue;\n}\n\n.perm-btn.selected.edit {\n  background-color: $permission-green;\n}\n\n.perm-btn.selected.not-shared {\n  background-color: $permission-orange;\n}\n\n.perm-btn:hover {\n  opacity: 0.9;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
